module.exports = __webpack_public_path__ + "static/media/image2.b8b80d98.webp";